import { useState, useEffect } from 'react';
import AreaService from '../service/AreaService';

export function useGetAreas() {
  const [areaList, setAreaList] = useState([]);

  useEffect(() => {
    AreaService.getAll()
      .then((response) => {
        if (response.data.data.length > 0) {
          let areaOptionsList = response.data.data.map((area) => {
            return { responsableArea: area.id, label: area.descricao };
          });

          setAreaList(areaOptionsList);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    areaList,
    setAreaList
  };
}
